import { render, staticRenderFns } from "./EmailDesign.vue?vue&type=template&id=e5e2021c"
import script from "./EmailDesign.vue?vue&type=script&lang=js"
export * from "./EmailDesign.vue?vue&type=script&lang=js"
import style0 from "./EmailDesign.vue?vue&type=style&index=0&id=e5e2021c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports